import { validationStatusType } from '@/constants';
const initData = () => ({
    show: false,
    message: [],
    // TODO 사용처 불명확함. 추후 확인 후 제거 필요
    messageProps: null,
    timeout: 3_000,
    status: validationStatusType.success,
});
const state = initData();
export default state;
